/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

const CELL_TYPES = Object.freeze({
  ACTION: 'actionCell',
  COMBINED: 'combinedCell',
  DEFAULT: 'default',
  SELECT_ALL: 'selectAll',
  STATUS: 'status',
  INVITATION_STATUS: 'invitationStatus',
  ROLES: 'roles',
});

const TABLE_SIZE = Object.freeze({
  MEDIUM: 'medium',
  SMALL: 'small',
});

export { CELL_TYPES, TABLE_SIZE };
